import _actions_get_items from './_actions/get_items.js'
import _mutations_loading from './_mutations/loading.js'
import _mutations_items from './_mutations/items.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        items: _mutations_items,
        loading: _mutations_loading,
    },
    actions:{
        get_items: _actions_get_items,
    },
}